import { useLegacyCard } from '@/src/common/hooks/useCardInformation'
import { useLegacyPaymentCard } from '@/src/app/main/(tabs)/card/card-management/virtual-card/highnote/useLegacyPaymentCard'
import { GET_LINKED_EXTERNAL_ACCOUNTS } from '@/src/common/gql/queries/card'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { FinancialAccountStatus } from '@api/highnote/graphql'
import { LegacyCardBack } from '@/src/experiences/virtual-card/components/LegacyCardBack'
import type { VirtualCardComponent } from '@/src/experiences/virtual-card/withVirtualCard'

export function LegacyVirtualCard({ ToWrap }: { ToWrap: VirtualCardComponent }) {
  const cardInformation = useLegacyCard().data?.getCreditCardInformation.node
  const paymentCardId = cardInformation?.id
  const paymentCard = useLegacyPaymentCard({
    variables: paymentCardId ? { paymentCardId } : undefined,
  })
  const hasCardToActivate = cardInformation?.virtualCardIdForPhysicalCard
  const hasCardShipped = cardInformation?.physicalCardTrackingNumber
  const { data: accounts, loading: loadingAccounts } = useLoggedInQuery(
    GET_LINKED_EXTERNAL_ACCOUNTS,
    { fetchPolicy: 'cache-and-network' },
  )

  const financialAccountStatus = cardInformation?.financialAccount.accountStatus

  return (
    <ToWrap
      cardLoaded={!!paymentCard}
      paymentMethodsLoaded={!loadingAccounts}
      cardAccountActive={financialAccountStatus === FinancialAccountStatus.Active}
      hasPaymentProfile={accounts?.getLinkedExternalBankAccounts.accounts.some(
        (account) => account.isVerified,
      )}
      shipmentStatus={
        hasCardToActivate
          ? hasCardShipped
            ? 'PENDING_ACTIVATION'
            : 'PENDING_FULFILLMENT'
          : 'ACTIVE'
      }
      {...(paymentCardId ? { freezeParams: { paymentCardId } } : undefined)}
      cardBackContent={<LegacyCardBack paymentCard={paymentCard} />}
    />
  )
}
